<!--
 * @Description:
 * @Autor: gxd
 * @Date: 2020-12-30 12:00:37
 * @LastEditors: gxd
 * @LastEditTime: 2020-12-30 15:12:58
-->
<template>
  <div class="longpress-share">
    <div class="longpress-share-left">
      <div class="longpress-share-img-box">
        <img src='../assets/images/v4.1/share-arrow-up.png'>
      </div>
      <div class="longpress-share-desc">长按海报保存，分享到朋友圈</div>
    </div>
    <div class="longpress-share-right" @click="copyInviteMsg()">复制分享语</div>
  </div>
</template>

<script>
export default {
  name: 'longpressShare',
  methods: {
    // 调用app分享。 埋点父组件添加其它参数：比如posterId 等
    copyInviteMsg (scence) {
      this.$emit('copyInviteMsg', scence)
    }
  }
}
</script>
<style lang="scss" scoped>
.longpress-share {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 310px;
  height: 45px;
  margin: 5px auto 0;
  text-align: center;
  color: #8e402c;
  background: #fdf7f0;
  border-radius: 15px;

  .longpress-share-left {
    display: flex;
    align-items: center;
    height: 20px;

    .longpress-share-img-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 14px;
      height: 13px;
      margin-left: 10px;

      img {
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
      }
    }

    .longpress-share-desc {
      margin-left: 4px;
      font-size: 13px;
    }
  }

  .longpress-share-right {
    width: 88px;
    height: 32px;
    margin-right: 3px;
    font-size: 13px;
    line-height: 32px;
    color: #fff;
    background-image: linear-gradient(#eb7e66, #e44a2c);
    border-radius: 16px;
  }
}
</style>
